import React, { Children } from 'react';
import { motion } from 'framer-motion';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 60
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.1,
      ease: [0.2, 0.65, 0.3, 0.9]
    }
  }
};
const container = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.18
    }
  }
};
export function ImpactBanner() {
  return <section className="w-full py-24 md:py-32 px-6 overflow-hidden" data-id="element-80">
      <div className="max-w-5xl mx-auto" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1,
        ease: [0.2, 0.65, 0.3, 0.9]
      }} className="text-center mb-16 md:mb-20" data-id="element-82">
          <h2 className="text-4xl md:text-6xl text-forest italic" data-id="element-83">
            Una marca que florece
          </h2>
          <p className="mt-5 text-base md:text-lg text-forest/60 max-w-xl mx-auto tracking-wide" data-id="element-84">
            Cada detalle, desde nuestra entrega hasta tu hogar, es una extensión
            de nuestra identidad.
          </p>
        </motion.div>

        <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.15
      }} className="flex flex-col gap-6 md:gap-8" data-id="element-85">
          {/* Top row — celular (left, leaf shape) + van (right, rounded rectangle) */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8" data-id="element-86">
            {/* celular — asymmetric leaf shape: rounded top-left & bottom-right */}
            <motion.figure variants={fadeUp} whileHover={{
            y: -8
          }} transition={{
            type: 'spring',
            stiffness: 200,
            damping: 20
          }} className="overflow-hidden rounded-tl-[3.5rem] rounded-br-[3.5rem] rounded-tr-lg rounded-bl-lg shadow-sm aspect-[4/3]" data-id="element-87">
              <img src="https://cdn.magicpatterns.com/uploads/dnLdaxySPyb3MUCZ9bQwB1/celular.png" alt="Aplicación móvil The Botanical Gallery" className="w-full h-full object-cover" data-id="element-88" />
            </motion.figure>

            {/* van — leaf shape inverse of celular: rounded top-right & bottom-left */}
            <motion.figure variants={fadeUp} whileHover={{
            y: -8
          }} transition={{
            type: 'spring',
            stiffness: 200,
            damping: 20
          }} className="overflow-hidden rounded-tr-[3.5rem] rounded-bl-[3.5rem] rounded-tl-lg rounded-br-lg shadow-sm aspect-[4/3]" data-id="element-89">
              <img src="https://cdn.magicpatterns.com/uploads/jagb1C6chWQ61UZro1pNwR/van.png" alt="Van de reparto The Botanical Gallery" className="w-full h-full object-cover" data-id="element-90" />
            </motion.figure>
          </div>

          {/* Bottom row — ramo 1 (leaf) + bolsa (center, larger squircle) + ramo 2 (circle) */}
          <div className="grid grid-cols-2 md:grid-cols-12 gap-6 md:gap-8 items-center" data-id="element-91">
            {/* ramo 1 — leaf shape: rounded top-right & bottom-left */}
            <motion.figure variants={fadeUp} whileHover={{
            y: -8
          }} transition={{
            type: 'spring',
            stiffness: 200,
            damping: 20
          }} className="overflow-hidden rounded-tr-[3.5rem] rounded-bl-[3.5rem] rounded-tl-lg rounded-br-lg shadow-sm aspect-square md:col-span-3" data-id="element-92">
              <img src="https://cdn.magicpatterns.com/uploads/uWDHKtJfF9ZjWfoKASUpZH/ramo_1.jpg" alt="Ramo de flores silvestres" className="w-full h-full object-cover" data-id="element-93" />
            </motion.figure>

            {/* bolsa — center, larger, heavily rounded squircle */}
            <motion.figure variants={fadeUp} whileHover={{
            y: -10
          }} transition={{
            type: 'spring',
            stiffness: 200,
            damping: 20
          }} className="col-span-2 md:col-span-6 overflow-hidden rounded-[3rem] shadow-md aspect-[4/5] md:-mt-6" data-id="element-94">
              <img src="https://cdn.magicpatterns.com/uploads/s3Yjjo2T9ikZQtyVMz8DFm/bolsa.png" alt="Bolsa de regalo The Botanical Gallery con flores" className="w-full h-full object-cover" data-id="element-95" />
            </motion.figure>

            {/* ramo 2 — leaf shape inverse of ramo 1: rounded top-left & bottom-right */}
            <motion.figure variants={fadeUp} whileHover={{
            y: -8
          }} transition={{
            type: 'spring',
            stiffness: 200,
            damping: 20
          }} className="overflow-hidden rounded-tl-[3.5rem] rounded-br-[3.5rem] rounded-tr-lg rounded-bl-lg shadow-sm aspect-square md:col-span-3" data-id="element-96">
              <img src="https://cdn.magicpatterns.com/uploads/qJTmtcBnVGWgnwqyXNgFTM/ramo_2.jpg" alt="Ramo de flores en tonos pastel" className="w-full h-full object-cover" data-id="element-97" />
            </motion.figure>
          </div>
        </motion.div>
      </div>
    </section>;
}